import "./styles.css";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import Button from "../Button/Button";
import { useUser } from "../../context/UserContext";
import { useAmplitude } from "../../context/AmplitudeContext";
import { useConfig } from "../../context/ConfigContext";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const Email = ({ updateEmail, updateUserInfo }) => {
  const { t } = useTranslation("questionsModule");
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  const { uid } = useUser();
  const trackEvent = useAmplitude();
  const { configData } = useConfig();

  const handleTextInputChange = (event) => {
    setEmail(event.target.value);
    const isEmailValid = emailRegex.test(event.target.value);
    setIsEmailValid(isEmailValid);
  };

  const trackEmailOnContinue = () => {
    trackEvent("webapp_user_email_v2", uid, "", email);
  };

  // Check the user comes to email page
  useEffect(() => {
    trackEvent("webapp_user_visited_email_page", uid);
  }, [uid, trackEvent]);

  return (
    <>
      <div className="question-module-header">
        <h4 className="email-title">E-Mail</h4>
        <p className="email-info">{t("email-detail")}</p>
      </div>
      <div className="question-module-input-wrapper">
        <input
          type="text"
          placeholder={t("email-placeholder")}
          value={email}
          onChange={handleTextInputChange}
          className="email-input-field"
        />
      </div>
      {configData.QuestionsModuleFlags?.isSkipEmailEnabled && (
        <div className="question-module-btn-wrapper-top">
          <Button
            text={t("skip")}
            onClick={() => {
              updateEmail("");
              updateUserInfo({ email: "" });
              trackEmailOnContinue();
            }}
            alternateColor={false}
            usePrimaryColor={false}
          />
        </div>
      )}
      <div className="question-module-btn-wrapper-bottom">
        <Button
          text={t("continue")}
          onClick={() => {
            updateEmail(email);
            updateUserInfo({ email: email });
            trackEmailOnContinue();
          }}
          disabled={!isEmailValid}
          alternateColor={true}
        />
      </div>
    </>
  );
};
